import React, { useEffect, useState } from 'react';
import { Search, Filter, Stethoscope, Calendar, Clock, Phone, Mail, Heart, Edit3, Trash2, CheckCircle, X } from 'lucide-react';
// import { servicesList } from '../data/mockData';
import axios from 'axios';
import ReactLoading from "react-loading";

const styles = `
  /* ── Toggle layouts ── */
  .table-desktop { display: block; }
  .table-mobile  { display: none; }

  /* ── Mobile card list ── */
  .bookings-cards {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
  }

  .booking-card {
    background: var(--bg-card);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    overflow: hidden;
    transition: border-color 0.2s, box-shadow 0.2s;
    animation: fadeInUp 0.4s ease forwards;
    opacity: 0;
    margin: 25px 0px;
  }

  .booking-card:hover {
    border-color: var(--border-light);
    box-shadow: var(--shadow);
  }

  .booking-card.editing {
    border-color: var(--primary);
    background: var(--primary-glow);
  }

  .booking-card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 16px 10px;
    border-bottom: 1px solid var(--border);
    flex-wrap: wrap;
  }

  .booking-card-body {
    padding: 10px 16px;
  }

  .booking-card-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
  }

  .booking-card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px 14px;
    border-top: 1px solid var(--border);
  }

  .booking-card-edit {
    padding: 14px 16px;
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .booking-card-edit-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
 

    .table-desktop { display: block; }
    .table-mobile  { display: none; }
  
  /* ── Swap at 768px ── */
  @media (max-width: 992px) {
    .table-desktop { display: none; }
    .table-mobile  { display: block; }
  }

  @media (max-width: 480px) {
    .booking-card-row {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
    .booking-card-header {
      gap: 8px;
    }
  }
`;

function getStatusColor(status) {
  switch(status) {
    case 'complete': return 'status-confirmed';
    case 'pending': return 'status-pending';
    // case 'ملغي': return 'status-cancelled';
    default: return '';
  }
}

function getStatusIcon(status) {
  switch(status) {
    case 'complete': return <CheckCircle size={14} />;
    case 'pending': return <Clock size={14} />;
    // case 'cancelled': return <X size={14} />;
    default: return null;
  }
}

export default function BookingsTable({ bookings, onDelete, onEdit }) {

  const [changedID , setChangedID] = useState(0)
const [servicesList , setservicesList] = useState([
  {name : ""}
])
  const [shownData , setShownData] = useState([
    {
      name : "" ,
      phone : "" ,
      email : "" ,
      service : "" ,
      date : "" ,
      status : "" ,

    }
  ])
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [serviceFilter, setServiceFilter] = useState('all');
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

const filtered = shownData.filter(b => {
  const term = searchTerm.toLowerCase();
  const matchesSearch =
    b.name?.toLowerCase().includes(term) ||
    b.phone?.includes(term) ||
    b.notes?.toLowerCase().includes(term) ||
    b.email?.toLowerCase().includes(term);
  const matchesStatus = statusFilter === 'all' || b.status === statusFilter;
  const matchesService = serviceFilter === 'all' || b.notes === serviceFilter;
  return matchesSearch && matchesStatus && matchesService;
});

  const sorted = [...filtered].sort((a, b) => {
    if (!sortConfig.key) return 0;
    const aVal = a[sortConfig.key];
    const bVal = b[sortConfig.key];
    if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });

  const handleSort = (key) => {
    setSortConfig(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc'
    }));
  };

  const handleEdit = (booking) => {
    setEditingId(booking.id);
    setEditForm({ ...booking });
    // editForm
  };

  const handleSave = (booking) => {
    const service = servicesList.find(s => s.name === editForm.service);
    onEdit(editingId, editForm);
    setEditingId(null);
    axios.put(`https://dr-mohamed-khaled.site/api/patients/${booking.id}`, editForm)
    .then((response) => { 
     setChangedID(Math.random())})
    
   
  }

  const handleCancel = () => {
    setEditingId(null);
    setEditForm({});
  };

  const handleDeleteClick = (id) => {
    if (window.confirm('هل أنت متأكد من حذف هذا الحجز؟')) {
      axios.delete(`https://dr-mohamed-khaled.site/api/patients/${id}`)
      // onDelete(id);
      setShownData(prev => prev.filter(item => item.id !== id));

    }
  };

  const resetFilters = () => {
    setSearchTerm('');
    setStatusFilter('all');
    setServiceFilter('all');
  };

  const [isloading , setisloading] = useState(false)

//   const getData = ()=>{
//     setisloading(true);
//  axios.get("https://dr-mohamed-khaled.site/api/patients")
// .then((response) => { 
//     const patients = response?.data?.patients || [];
//     setShownData(patients);
//     // build unique services list (unique by service name)
//     const seen = new Set();
//     const services = [];
//     patients.forEach((p, idx) => {
//       const serviceName = p?.notes || '';
//       if (serviceName && !seen.has(serviceName)) {
//         seen.add(serviceName);
//         services.push({ id: idx, name: serviceName });
//       }
//     });
//     setservicesList(services);
//     console.log(services);
//     setisloading(false);
//  })
//  .catch((err) => console.error(err));
//   }

const getData = (showLoading = false) => {
  if (showLoading) setisloading(true);
  
  axios.get("https://dr-mohamed-khaled.site/api/patients")
    .then((response) => {
      const patients = response?.data?.patients || [];
      setShownData(patients);
      
      const seen = new Set();
      const services = [];
      patients.forEach((p, idx) => {
        const serviceName = p?.notes || '';
        if (serviceName && !seen.has(serviceName)) {
          seen.add(serviceName);
          services.push({ id: idx, name: serviceName });
        }
      });
      setservicesList(services);
      setisloading(false);
    })
    .catch((err) => console.error(err));
};

useEffect(() => {
  getData(true); // أول مرة بس يبان الـ loading

  const interval = setInterval(() => {
    getData(false); // الـ refresh من غير loading
  }, 2000);

  return () => clearInterval(interval);
}, []);


  useEffect(() => {
    setservicesList([]);
  //  getData()

 } 
, [])


  useEffect(() => {
    setservicesList([]);
   getData()

 } 
, [changedID])

if(isloading){
  return(
  <div style={{display : "flex" , justifyContent : "center" , alignItems : "center" , flexDirection : "column" , height : "100%"}}>
  <h2>Loading...</h2>
  <ReactLoading type="spin" color="#0000FF" height={100} width={50} />
  </div>
  )
}
  return (
    <div className="bookings-section">
      {/* Inject scoped styles once */}
      <style>{styles}</style>

      {/* ── Filters ── */}
      <div className="filters-bar">
        <div className="search-box">
          <Search size={18} />
          <input
            type="text"
            placeholder="بحث بالاسم، الهاتف، البريد، أو الخدمة..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          {searchTerm && (
            <button className="clear-search" onClick={() => setSearchTerm('')}>
              <X size={14} />
            </button>
          )}
        </div>
        <div className="filter-group">
          <Filter size={16} />
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
            <option value="all">جميع الحالات</option>
            <option value="complete">مؤكد</option>
            <option value="pending">قيد الانتظار</option>
            {/* <option value="cancelled">ملغي</option> */}
          </select>
        </div>
        <div className="filter-group">
          <Stethoscope size={16} />
          <select value={serviceFilter} onChange={(e) => setServiceFilter(e.target.value)}>
            <option value="all">جميع الخدمات</option>
            {servicesList.map(s => (
              <option key={s.id} value={s.name}>{s.name}</option>
            ))}
          </select>
        </div>
      </div>

      {shownData.length === 0 ? (
        <div className="table-container">
          <div className="empty-state">
            <div className="empty-content">
              <Search size={40} className="empty-icon" />
              <p>لا توجد نتائج</p>
              <button className="btn-text" onClick={resetFilters}>إعادة ضبط</button>
            </div>
          </div>
        </div>
      ) : (
        <>
          {/* ── Desktop table ── */}
          <div className="table-container table-desktop">
            <div className="table-scroll">
              <table className="bookings-table">
                <thead>
                  <tr>
                    <th onClick={() => handleSort('id')} className="sortable">
                      # {sortConfig.key === 'id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                    </th>
                    <th>المريض</th>
                    <th onClick={() => handleSort('service')} className="sortable">
                      الخدمة {sortConfig.key === 'service' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                    </th>
                    <th onClick={() => handleSort('date')} className="sortable">
                     تاريخ الحجز {sortConfig.key === 'date' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                    </th>
                    <th>الحالة</th>
                    <th>إجراءات</th>
                  </tr>
                </thead>
                <tbody>
                  {sorted.map((booking, index) => (
                    <tr key={booking.id} className={editingId === booking.id ? 'editing' : ''}>
                      {editingId === booking?.id ? (
                        <>
                          <td className="cell-id">{index + 1}</td>
                          <td>
                            <div className="edit-group">
                              <input value={editForm.name} onChange={(e) => setEditForm({...editForm, name: e.target.value})} className="edit-input" placeholder="الاسم" />
                              <input value={editForm.phone} onChange={(e) => setEditForm({...editForm, phone: e.target.value})} className="edit-input small" placeholder="الهاتف" />
                              <input value={editForm.email} onChange={(e) => setEditForm({...editForm, email: e.target.value})} className="edit-input small" placeholder="البريد" />
                            </div>
                          </td>
                          <td>
                            <select value={editForm.service} onChange={(e) => setEditForm({...editForm, notes: e.target.value})} className="edit-input">
                              {servicesList.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                            </select>
                          </td>
                          <td>
                            <input type="date" value={editForm.date} onChange={(e) => setEditForm({...editForm, created_at: e.target.value})} className="edit-input" />
                          </td>
                          <td>
                            <select value={editForm.status} onChange={(e) => setEditForm({...editForm, status: e.target.value})} className="edit-input">
                              <option value="complete">مؤكد</option>
                              <option value="pending">قيد الانتظار</option>
                              {/* <option value="cancelled">ملغي</option> */}
                            </select>
                          </td>
                          <td>
                            <div className="action-btns">
                              <button className="btn-save" onClick={()=> handleSave(booking)} title="حفظ"><CheckCircle size={16} /></button>
                              <button className="btn-cancel" onClick={handleCancel} title="إلغاء"><X size={16} /></button>
                            </div>
                          </td>
                        </>
                      ) : (
                        <>
                          <td className="cell-id">{index + 1}</td>
                          <td>
                            <div className="patient-info">
                              <div className="patient-avatar">{booking.name.charAt(0)}</div>
                              <div className="patient-details">
                                <div className="patient-name">{booking.name}</div>
                                <div className="patient-contact">
                                  <span><Phone size={10} /> {booking.phone}</span>
                                  <span><Mail size={10} /> {booking.email}</span>
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className="service-cell">
                              <Heart size={14} className="service-icon" />
                              <span>{booking.notes}</span>
                            </div>
                          </td>
                          <td>
                            <div className="date-cell">
                              <Calendar size={14} /><span>{new Date(booking.created_at).toLocaleDateString()}</span>
                            </div>
                          </td>
                          <td>
                            <span className={`status-badge ${getStatusColor(booking.status)}`}>
                              {getStatusIcon(booking?.status)}<span>{booking?.status == 'complete' ? 'مؤكد' : booking?.status == 'pending' ? 'قيد الانتظار' : 'ملغي'}</span>
                            </span>
                          </td>
                          <td>
                            <div className="action-btns">
                              <button className="btn-edit" onClick={() => handleEdit(booking)} title="تعديل"><Edit3 size={16} /></button>
                              <button className="btn-delete" onClick={() => handleDeleteClick(booking?.id)} title="حذف"><Trash2 size={16} /></button>
                            </div>
                          </td>
                        </>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* ── Mobile cards ── */}
          <div className="bookings-cards table-mobile">
            {sorted.map((booking, index) => (
              <div key={booking.id} className={`booking-card  ${editingId === booking.id ? 'editing' : ''}`}>
                {editingId === booking.id ? (
                  <div className="booking-card-edit">
                    <div className="booking-card-edit-header">
                      <span className="cell-id">#{index + 1}</span>
                      <div className="action-btns">
                        <button className="btn-save" onClick={() => handleSave(booking)} title="حفظ"><CheckCircle size={16} /></button>
                        <button className="btn-cancel" onClick={handleCancel} title="إلغاء"><X size={16} /></button>
                      </div>
                    </div>
                    <div className="edit-group">
                      <input value={editForm.name} onChange={(e) => setEditForm({...editForm, name: e.target.value})} className="edit-input" placeholder="الاسم" />
                      <input value={editForm.phone} onChange={(e) => setEditForm({...editForm, phone: e.target.value})} className="edit-input small" placeholder="الهاتف" />
                      <input value={editForm.email} onChange={(e) => setEditForm({...editForm, email: e.target.value})} className="edit-input small" placeholder="البريد" />
                      <select value={editForm.service} onChange={(e) => setEditForm({...editForm, service: e.target.value})} className="edit-input">
                        {servicesList.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                      </select>
                      <input type="date" value={editForm.date} onChange={(e) => setEditForm({...editForm, date: e.target.value})} className="edit-input" />
                      <select value={editForm.status} onChange={(e) => setEditForm({...editForm, status: e.target.value})} className="edit-input">
                        <option value="complete">مؤكد</option>
                        <option value="pending">قيد الانتظار</option>
                        {/* <option value="cancelled">ملغي</option> */}
                      </select>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="booking-card-header">
                      <div className="patient-info">
                        <div className="patient-avatar">{booking.name.charAt(0)}</div>
                        <div className="patient-details">
                          <div className="patient-name">{booking.name}</div>
                          <div className="patient-contact">
                            <span><Phone size={10} /> {booking.phone}</span>
                            <span><Mail size={10} /> {booking.email}</span>
                          </div>
                        </div>
                      </div>
                      <span className={`status-badge ${getStatusColor(booking.status )}`}>
                        {getStatusIcon(booking.status)}<span>{booking?.status == 'complete' ? 'مؤكد' : booking?.status == 'pending' ? 'قيد الانتظار' : 'ملغي'}</span>
                      </span>
                    </div>

                    <div className="booking-card-body">
                      <div className="booking-card-row">
                        <div className="service-cell">
                          <Heart size={14} className="service-icon" />
                          <span>{booking.notes}</span>
                        </div>
                        <div className="date-cell">
                       <Calendar size={14} /><span>{new Date(booking.created_at).toLocaleDateString()}</span>
                        </div>
                      </div>
                    </div>

                    <div className="booking-card-footer">
                      <span className="cell-id">#{index + 1}</span>
                      <div className="action-btns">
                        <button className="btn-edit" onClick={() => handleEdit(booking)} title="تعديل"><Edit3 size={16} /></button>
                        <button className="btn-delete" onClick={() => handleDeleteClick(booking.id)} title="حذف"><Trash2 size={16} /></button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}